import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookMark {
    id: number;
    book_id: number;
    cfi: string;
    page_no: number;
    href: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}
interface BookmarkState {
    bookmarks: BookMark[];
}

const initialState: BookmarkState = {
    bookmarks: [],
};

const bookmarksSlice = createSlice({
    name: 'bookmarks',
    initialState,
    reducers: {
        setBookmarks: (state, action: PayloadAction<BookMark[]>) => {
            state.bookmarks = action.payload;
        },
        appendBookmark: (state, action: PayloadAction<BookMark>) => {
            state.bookmarks.push(action.payload);
        },
        removeBookmark: (state, action: PayloadAction<number>) => {
            state.bookmarks = state.bookmarks.filter(
                (bookmark: any) => bookmark.id !== action.payload
            );
        },
    },
});

export const { setBookmarks, appendBookmark, removeBookmark } =
    bookmarksSlice.actions;

export default bookmarksSlice.reducer;
